import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SharedAuthService } from '../../shared.auth.service';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-footer2',
    templateUrl: './footer2.component.html',
    styleUrls: ['./theme-2-style.css', './footer2.component.css'],
    imports: [RouterLink, MatTooltip]
})
export class Footer2Component implements AfterViewInit, OnInit {
  outlookHref: string;
  currentYear: any;
  constructor(private sharedAuthService: SharedAuthService) {}

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    const msId = this.sharedAuthService.getMsid();
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (currentUser) {
      this.outlookHref = `mailto:techopshub_support@uhg.com?subject=${currentUser.replace(
        /^"(.*)"$/,
        '$1'
      )} (${msId}) has contacted!`;
    }
  }
  ngAfterViewInit() {
    const returnUrl = localStorage.getItem('returnUrl')
      ? window.location.host + localStorage.getItem('returnUrl')
      : null;
    const currenturl = window.location.href;
    if (returnUrl == currenturl) {
      localStorage.removeItem('returnUrl');
    }
  }
}
